import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, watch, watchEffect } from "vue";
import { ElConfigProvider } from "element-plus";
import zh from "element-plus/es/locale/lang/zh-cn";
import en from "element-plus/es/locale/lang/en";
import { useStore } from "@/store/index";
export default {
  __name: 'App',
  setup(__props) {
    const store = useStore();
    const locale = ref(null);
    watchEffect(() => {
      locale.value = store.language === "zh" ? zh : en;
    });
    watch(() => store.token, token => {
      if (!token) return;
      // 创建 WebSocket 连接
    }, {
      immediate: true
    });
    const debounce = (fn, delay) => {
      let timer;
      return (...args) => {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          fn(...args);
        }, delay);
      };
    };
    const _ResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
      constructor(callback) {
        callback = debounce(callback, 200);
        super(callback);
      }
    };
    // const zoom = window.innerWidth / 1920;
    // document.body.style.zoom = zoom;

    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_unref(ElConfigProvider), {
        locale: locale.value
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view, {
          style: {
            "width": "100%"
          }
        })]),
        _: 1
      }, 8, ["locale"]);
    };
  }
};